import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { citationsApi } from './Citationsapi';
import { fmtDate, Cost } from './Citationui';


export default function CitationResult({ userId, result, query, prices, onBalance }) {
  const [open, setOpen] = useState(false);
  const [frag, setFrag] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const toggle = async () => {
    if (open) { setOpen(false); return; }
    setOpen(true);
    if (frag) return;
    setLoading(true);
    setError(null);
    try {
      const r = await citationsApi.fragments(userId, result.tid, query);
      setFrag(r);
      if (onBalance && r.balance) onBalance(r.balance);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <article className="ec-result cite-result">
      <Link to={`/citations/doc/${result.tid}`} className="ec-link-plain">
        <div className="ec-result-title">{result.title || 'Untitled judgment'}</div>
      </Link>
      {(result.court || result.date) && (
        <div className="small ec-muted">{[result.court, fmtDate(result.date)].filter(Boolean).join(' · ')}</div>
      )}
      {result.snippet && <div className="small mt-1 cite-snippet">{result.snippet}</div>}

      <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
        {result.numCitedBy ? <span className="small ec-muted me-2">Cited by {Number(result.numCitedBy).toLocaleString('en-IN')}</span> : null}
        <button type="button" className="btn btn-sm btn-ec-outline" onClick={toggle} aria-expanded={open}>
          <FontAwesomeIcon icon={open ? faChevronUp : faAlignLeft} />
          {open ? 'Hide paragraphs' : 'Show where it matches'}
          {!frag && !open && <Cost prices={prices} kind="docfragment" />}
        </button>
        <Link to={`/citations/doc/${result.tid}`} className="btn btn-sm btn-ec-outline">
          Open judgment {prices && <Cost prices={prices} kind="doc" />}
        </Link>
      </div>

      {open && (
        <div className="cite-frags mt-2">
          {loading && <div className="small ec-muted">Finding matching paragraphs…</div>}
          {error && <div className="small ec-field-error" role="alert">{error.message}</div>}
          {frag && (frag.fragments.length === 0
            ? <div className="small ec-muted">No matching paragraph found. Open the judgment to read it in full.</div>
            : frag.fragments.map((t, i) => <blockquote key={i} className="cite-frag">{t}</blockquote>))}
        </div>
      )}
    </article>
  );
}